import { apiService } from "./apiService";
import { endpoints } from "@/config/endpoints";
import { pickBy } from "lodash";

export default {
  getFacilitiesData({
    page,
    perPage,
    query,
    city,
    is_owner,
    is_verified,
    external_changes_status = [],
    external_changes_source = [],
    external_changes_fields = [],
    cities = [],
    facilities_ids = [],
    groups = [],
    location_state,
    open_status,
    bing_status,
    apple_status,
    without_gmb_address = false,
    store_codes,
    only_basic_info,
    selected_facilities_ids = []
  }) {
    const paginationParams = {
      page: page,
      page_size: perPage
    };

    const body = {
      q: query,
      city: city,
      is_owner: is_owner,
      is_verified,
      external_changes_status: external_changes_status.join(","),
      external_changes_source: external_changes_source.join(","),
      external_changes_fields: external_changes_fields.join(","),
      cities: cities.join(","),
      facilities_ids: facilities_ids.join(","),
      groups: groups.join(","),
      location_state,
      open_status,
      bing_status,
      apple_status,
      without_gmb_address,
      store_codes,
      only_basic_info,
      selected_facilities_ids: selected_facilities_ids.join(",")
    };

    return apiService.post(endpoints.facilities, pickBy(body), {
      params: pickBy(paginationParams)
    });
  },

  getFacilitiesCities() {
    return apiService.get(endpoints.facilitiesCities);
  },

  getFacilitiesIds({
    query,
    city,
    is_owner,
    is_verified,
    external_changes_status = [],
    external_changes_source = [],
    external_changes_fields = [],
    cities = [],
    facilities_ids = [],
    groups = [],
    location_state,
    open_status,
    bing_status,
    apple_status,
    has_physical_location = false
  }) {
    const body = {
      only_ids: true,
      q: query,
      city: city,
      is_owner: is_owner,
      is_verified,
      external_changes_status: external_changes_status.join(","),
      external_changes_source: external_changes_source.join(","),
      external_changes_fields: external_changes_fields.join(","),
      cities: cities.join(","),
      facilities_ids: facilities_ids.join(","),
      groups: groups.join(","),
      location_state,
      open_status,
      bing_status,
      apple_status,
      has_physical_location
    };

    return apiService.post(endpoints.facilities, pickBy(body));
  },

  // Unpaginated, lightweight listing for selection UIs (filter dialog):
  // id, gmb_address_id, name, formatted_address, store_code, business_type, is_owner.
  getFacilitiesBasicInfo({ is_owner, is_verified, open_status }) {
    const body = {
      only_basic_info: true,
      is_owner,
      is_verified,
      open_status
    };

    return apiService.post(endpoints.facilities, pickBy(body));
  },

  getFacilityData(facilityId) {
    return apiService.get(`${endpoints.facilities}${facilityId}/`);
  },

  fetchFacilitiesLabels() {
    return apiService.get(endpoints.facilitiesLabels);
  },

  fetchFacilitiesLabelsByIds(facilitiesIds) {
    return apiService.post(endpoints.facilitiesLabels, {
      facilities_ids: facilitiesIds
    });
  },

  fetchFacilitiesMoreHours({ facilitiesIds = [], onlySet = false }) {
    const params = {
      facilities_ids: facilitiesIds.join(","),
      only_set: onlySet
    };
    return apiService.post(endpoints.gmbMoreHours, pickBy(params));
  },

  getFacilityUpdateStatus(facilityId) {
    return apiService.get(
      `${endpoints.facilitiesUpdateStatuses}${facilityId}/`
    );
  },

  deleteFacility(facilityId) {
    return apiService.delete(`${endpoints.facilities}${facilityId}/`);
  },

  patchFacility(facilityId, payload) {
    return apiService.patch(`${endpoints.facilities}${facilityId}/`, payload);
  },

  removeUnavailableAttribute(facilityId, attributeId) {
    return apiService.post(
      `${endpoints.facilities}${facilityId}/remove-unavailable-attribute/`,
      { attribute_id: attributeId }
    );
  },

  importFacilityEditFile(form) {
    return apiService.post(endpoints.facilitiesImport, form);
  },

  putFacilitiesImport(payload) {
    return apiService.put(endpoints.facilitiesImport, payload);
  },

  patchFacilitiesBulkEdit(data) {
    return apiService.patch(endpoints.facilitiesBulkEdit, data);
  },

  exportFacilities({ type, ids }) {
    const payload = {
      facilities_ids: ids
    };
    const params = {
      file_type: type
    };

    return apiService.post(endpoints.facilitiesExport, payload, {
      params
    });
  },

  createFacility(payload) {
    return apiService.post(endpoints.gmbLocationCreate, payload);
  },

  createFacilityCheck(params) {
    return apiService.get(endpoints.gmbSearch, { params });
  },

  getCountries() {
    return apiService.get(endpoints.countries);
  },

  getAdministrativeAreas(countryCode) {
    return apiService.get(endpoints.administrativeAreas, {
      params: { country_code: countryCode }
    });
  },

  getFacilitiesForLimitsManagement() {
    return apiService.get(endpoints.facilitiesLimitsManagement);
  }
};
